import {
  IN_TO_CM,
  METERS_TO_FT,
  MPH_TO_KPH,
} from 'lib_ts/classes/math.utilities';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { isNil } from 'lodash';

// for converting imperial to metric
export class MetricHelper {
  static mphToKph<T extends Nullable<number>>(v?: T): T {
    if (isNil(v)) {
      return v as T;
    }

    return ((v as number) * MPH_TO_KPH) as T;
  }

  static kphToMph<T extends Nullable<number>>(v?: T): T {
    if (isNil(v)) {
      return v as T;
    }

    return ((v as number) / MPH_TO_KPH) as T;
  }

  static inToCm<T extends Nullable<number>>(v?: T): T {
    if (isNil(v)) {
      return v as T;
    }

    return ((v as number) * IN_TO_CM) as T;
  }

  static ftToM<T extends Nullable<number>>(v?: T): T {
    if (isNil(v)) {
      return v as T;
    }

    return ((v as number) / METERS_TO_FT) as T;
  }

  static ftToCm<T extends Nullable<number>>(v?: T): T {
    if (isNil(v)) {
      return v as T;
    }

    return (100 * ((v as number) / METERS_TO_FT)) as T;
  }

  static getSpeedUnit(isMetric?: boolean, toUpperCase?: boolean): string {
    const unit = isMetric ? 'kph' : 'mph';
    return toUpperCase ? unit.toUpperCase() : unit;
  }

  static getDistanceUnit(isMetric?: boolean, toUpperCase?: boolean): string {
    const unit = isMetric ? 'm' : 'ft';
    return toUpperCase ? unit.toUpperCase() : unit;
  }

  static getBreaksUnit(isMetric?: boolean, toUpperCase?: boolean): string {
    const unit = isMetric ? 'cm' : 'in';
    return toUpperCase ? unit.toUpperCase() : unit;
  }

  static getPositionUnit(isMetric?: boolean, toUpperCase?: boolean): string {
    const unit = isMetric ? 'cm' : 'ft';
    return toUpperCase ? unit.toUpperCase() : unit;
  }

  // e.g. for py where cm would not make sense
  static getLongPositionUnit(
    isMetric?: boolean,
    toUpperCase?: boolean
  ): string {
    const unit = isMetric ? 'm' : 'ft';
    return toUpperCase ? unit.toUpperCase() : unit;
  }
}
